export default __webpack_public_path__ + "static/activities_image_one-3e808380591abec0f4682fdd83c415f0.png";